import React, { useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import Chatbot from './routes/Chatbot/Chatbot'
import Login from './routes/TalentPlatform/Login/Login'
import ResetPassword from './routes/TalentPlatform/ResetPassword'

import { setTalent } from './redux/reducers/talentSlice'
import NewApply from './routes/NewApply/NewApply'
import ProtectedRoute from './routes/ProtectedRoute/ProtectedRoute'
import SoftApply from './routes/SoftApply/SoftApply'
import Company from './routes/TalentPlatform/Company/Company'
import Wrapper from './routes/TalentPlatform/OnboardingPage/OnboardingPage'
import ResumeUpload from './routes/TalentPlatform/ResumeUpload'
import TalentPlatform from './routes/TalentPlatform/TalentPlatform'
import AuthTalent from './services/AuthTalent'
import { FeathersContext } from './services/feathers'

const App = () => {
  const dispatch = useDispatch()
  const feathers = useContext(FeathersContext)
  const talent = useSelector((state) => state.talent)

  useEffect(() => {
    async function getTalent() {
      const token = AuthTalent.getToken()

      if (token) {
        const decoded = AuthTalent.decode(token)
        const response = await feathers.service('talents').get(decoded.talentId)
        dispatch(setTalent(response))
      }
    }
    if (!talent.id) {
      getTalent()
    }
  }, [talent])

  return (
    <Switch>
      <ProtectedRoute path="/app">
        <Route path="*" component={TalentPlatform} />
      </ProtectedRoute>
      <Route path="/upload/:id" component={ResumeUpload} />
      <Route path="/company/:companyName" component={Company} />
      <Route path="/login" component={Login} />
      <Route path="/reset-password/:token" component={ResetPassword} />
      <Route path="/signup/:token" component={Wrapper} />
      <Route path="/soft/:id" component={SoftApply} />
      <Route path="/new/:companyId" component={NewApply} />
      <Route path="/chat/:id" component={Chatbot} />
      <Route path="/:id" component={Chatbot} />
      <Route path="/" component={Chatbot} />
    </Switch>
  )
}

export default App
